/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Billing_Alltime_UnreadableInputs */



/**
* | output |
* | --- |
* | "{count} unreadable" |
*
* @param {Admin_Billing_Alltime_UnreadableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_alltime_unreadable = /** @type {((inputs: Admin_Billing_Alltime_UnreadableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Alltime_UnreadableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} nicht lesbar`)
	return /** @type {LocalizedString} */ (`${i?.count} unreadable`)
});